import ContainerLayout from '@/components/Layout/ContainerLayout';
import { Paper } from '@/components/Paper';
import { useRef, useState } from 'react';
import { Outlet } from 'react-router-dom';

import { useFetchList } from './service';
import { Spinner, Box, Icon, HStack,Image, Text, VStack, Divider } from '@chakra-ui/react';
import { WrapperTable } from '@/components/WrapperTable';
import Pagination from '@/components/Paginator';
import SlimTable from '../components/SlimTable';
import { headers, mockData } from './settings';
import { IoMdCheckmarkCircleOutline, IoMdWarning } from 'react-icons/io';
import { FaClock, FaRegCalendarAlt, FaTruck, FaUserFriends, FaWarehouse } from 'react-icons/fa';
import { PiSteeringWheelFill } from 'react-icons/pi';
import PersonMic from '../../../assets/Portaria/PersonMic.png';
import PersonSignal from '../../../assets/Portaria/PersonSignal.png';
import Block from '../../../assets/Portaria/Block.png';

// Dados de exemplo
const mainAlertData = {
  plate: 'SMO7G75',
  driver: 'RAIMUNDO FERREIRA SANTIAGO NETO',
  company: 'BC TRANSPORTES - Expedição',
  dock: 'DOCA 1',
};

const driverList = [
  { driver: 'Francisco Jose Nogueira Mariano', plate: 'HXA9A05', dock: 'DOCA - 1' },
  { driver: 'Ascanio Jorge dos Santos Cabral', plate: 'SEV6C61', dock: 'DOCA - 5' },
  { driver: 'Raimundo Ferreira Santiago Neto', plate: 'SMO7G75', dock: 'DOCA - 1' },
  { driver: 'Ciro Lopes de Sousa', plate: 'POP9645', dock: 'DOCA - 7' },
  { driver: 'Bruno Luis Alves da Silva', plate: 'SHY9H54', dock: 'DOCA - 3' },
  { driver: 'Jonimar Carneiro Santos', plate: 'SMO7H11', dock: 'DOCA - 2' },
];


function PainelChamadaAlerta() {
  return (
    <ContainerLayout>
      <Paper
        m={6}
        bg="white"
        py={4}
        px={2}
        rounded="xl"
        shadow="sm"
        border="1px solid rgba(200, 200, 200, .4)"
        h={'94%'}
        overflowY="auto"
      >
        {/* Header */}
        <HStack
          justify="space-between"
          align={'center'}
          border={"2px"}
          borderColor="#0f4f6d"
          borderRadius={"xl"}
          p={2}
        >
          <HStack>
            <Icon boxSize={6} as={IoMdCheckmarkCircleOutline} />
            <Text fontWeight="bold" fontSize={'xl'}>
              Acompanhamento Portaria - Painel Chamada Alerta
            </Text>
          </HStack>
          <HStack spacing={4} align="center">
            <HStack spacing={2} align="center">
              <Box as={FaRegCalendarAlt} boxSize={6} color={'rgba(15, 79, 109, 1)'}/>
              <Text fontSize={'md'} fontWeight={'bold'}>Data: {new Date().toLocaleDateString()}</Text>
            </HStack>
            <HStack spacing={2} align="center">
              <Box as={FaClock} boxSize={6} color={'rgba(15, 79, 109, 1)'}/>
              <Text fontSize={'md'} fontWeight={'bold'}>
                Hora: {new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
              </Text>
            </HStack>
          </HStack>
        </HStack>

        <VStack  spacing={4} align="stretch" p={4}>
          {/* Main Alert Panel */}
          <Box  borderRadius="lg"  bg="rgba(17, 123, 170, 1)" p={2}>
              <Box
                border={"1px solid white"}
                color="white"
                p={4}
                borderRadius="lg"
                textAlign="center"
              >
                <Box
                  bg="rgba(250, 188, 55, 1)"
                  color="black"
                  p={3}
                  borderRadius="lg"
                  mb={3}
                >
                  <HStack justify="center" align="center">
                    <Image src={PersonSignal} boxSize={16} alt="PersonSignal" />
                    <Text fontSize="5xl" fontWeight="extrabold" letterSpacing="widest" textShadow="0 2px 8px rgba(0,0,0,0.25)">
                      {mainAlertData.plate}
                    </Text>
                  </HStack>
                </Box>

                <VStack spacing={1}>
                  <HStack>
                    <Image src={PersonMic} w={'30px'} />
                    <Text fontSize="2xl" fontWeight="bold">{mainAlertData.driver}</Text>
                  </HStack>
                  <HStack>
                    <Image src={Block} boxSize={5} />
                    <Text fontSize="lg">{mainAlertData.company}</Text>
                  </HStack>
                  <HStack p={1} borderRadius="md" mt={2}>
                    <Icon as={IoMdWarning} color="yellow.400" boxSize={5} />
                    <Text fontSize="xl" fontWeight="bold">{mainAlertData.dock}</Text>
                  </HStack>
                </VStack>
              </Box>
          </Box>
        

          <VStack
            align="stretch"
            border="1px solid "
            borderColor="black"
            borderRadius="lg"
            overflow="hidden"
            p={3}
          >
            <Box  alignContent={'center'} textAlign={'center'} bg="rgba(17, 123, 170, 1)" left={20} borderRadius={'2xl'} w={'180px'}  p={1} color="white" top={'45%'} position="absolute" zIndex={1}>
              <Text fontWeight="bold" fontSize="lg">Motorista</Text>
            </Box>
            <Box h={'20px'}>

            </Box>

            {driverList.map((driver, index) => (
              <HStack
                key={index}
                justify="space-between"
                p={3}
                bg={index % 2 === 0 ? 'rgba(17, 123, 170, 0.59)' : 'rgba(250, 188, 55, 0.5)'}
                color={index % 2 === 0 ? 'white' : 'black'}
              >
                <Text w={'50%'} fontWeight="bold">{driver.driver}</Text>

                <Text fontWeight="bold">{driver.plate}</Text> 
                <Text w="100px" fontWeight={'bold'} textAlign="right">{driver.dock}</Text>
              </HStack>
            ))}

          </VStack>
        </VStack>
        
        <Outlet />
      </Paper>
    </ContainerLayout>
  );
}

export default PainelChamadaAlerta;